// 城市数据常量

// 热门城市列表
export const HOT_CITIES = [
  "北京",
  "上海",
  "广州",
  "深圳",
  "成都",
  "杭州",
  "重庆",
  "苏州",
  "武汉",
  "西安",
  "南京",
]

// 按首字母分组的城市数据
export const CITIES_BY_LETTER = {
  A: [
    "澳门",
    "阿坝",
    "安顺",
    "安康",
    "安阳",
    "阿里",
    "阿克苏",
    "阿勒泰",
    "阿拉尔",
    "阿拉善",
    "鞍山",
  ],
  B: [
    "北京",
    "保定",
    "蚌埠",
    "北海",
    "包头",
    "毕节",
    "亳州",
    "滨州",
    "巴中",
    "巴彦淖尔",
  ],
  C: ["长沙", "成都", "重庆", "滁州", "沧州", "常州", "郴州", "潮州"],
  D: ["大连", "东莞", "大同", "德州", "达州", "大理"],
  F: ["福州", "佛山", "抚顺", "抚州"],
  G: ["广州", "贵阳", "桂林", "赣州"],
  H: [
    "杭州",
    "合肥",
    "海口",
    "呼和浩特",
    "哈尔滨",
    "惠州",
    "衡阳",
    "湖州",
    "菏泽",
  ],
  J: ["济南", "嘉兴", "江门", "吉林", "锦州", "晋中", "荆州", "九江"],
  K: ["昆明", "开封"],
  L: [
    "拉萨",
    "廊坊",
    "丽江",
    "临沂",
    "连云港",
    "柳州",
    "洛阳",
    "兰州",
    "聊城",
  ],
  N: ["南京", "宁波", "南昌", "南通", "南宁"],
  Q: ["青岛", "泉州", "清远", "秦皇岛"],
  S: ["上海", "深圳", "石家庄", "沈阳", "绍兴", "汕头", "三亚", "宿迁"],
  T: ["天津", "太原", "台州", "唐山", "泰安"],
  W: ["武汉", "无锡", "威海", "温州", "乌鲁木齐"],
  X: ["西安", "厦门", "襄阳", "徐州", "新乡"],
  Y: ["银川", "宜昌", "烟台", "扬州", "宜宾"],
  Z: ["郑州", "中山", "珠海", "淄博", "遵义"],
}
